interface ExecuterType {
    start: () => void;
    stop: () => void;
}

const requestAnimFrame: (callback: FrameRequestCallback) => number = (function () {
    if (typeof window === 'undefined') {
        return () => -1;
    }
    return window.requestAnimationFrame
        || window.webkitRequestAnimationFrame
        || (window as any).mozRequestAnimationFrame
        || (window as any).oRequestAnimationFrame
        || (window as any).msRequestAnimationFrame
        || function (callback) {
            return window.setTimeout(callback, 1000 / 60, (new Date()).getTime());
        };
})();

const cancelAnimFrame: (handle: number) => void = (function () {
    if (typeof window === 'undefined') {
        return () => void 0;
    }
    return window.cancelAnimationFrame || window.webkitCancelAnimationFrame || (window as any).mozCancelAnimationFrame || function (id) {
        clearTimeout(id);
    };
}());

/**
 * 生成控制器（excuter）的函数工厂，返回可以控制开关的周期运行对象
 * @param callback 回调
 * @param interval 周期
 */
function intervalExecuter(callback: () => void | boolean, interval: number): ExecuterType {
    let requestId = -1;
    let record = 0;
    interval = interval || 16.667;

    const step = function (timestamp) {
        const past = timestamp - record;
        let toContinue = true;
        if (past >= interval) {
            toContinue = callback() !== false;
            record = timestamp;
        }
        requestId = toContinue ? requestAnimFrame(step) : -1;
    };

    return {
        start: () => {
            if (requestId === -1) {
                requestId = requestAnimFrame(step);
            }
        },
        stop: () => {
            cancelAnimFrame(requestId);
            requestId = -1;
        }
    };
}

export default intervalExecuter;
